export default __webpack_public_path__ + "static/splash-2-7bb4de8b4d40e8477a0ff7df0aa8f58a.png";